var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaignHistoryReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.672,
    height: 15.61,
    viewBox: "0 0 15.672 15.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Go_to_report",
    "data-name": "Go to report",
    transform: "translate(-0.27 -0.27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    d: "M8.372,15.28H2.534A1.666,1.666,0,0,1,.87,13.616V2.534A1.66,1.66,0,0,1,2.534.87h7.759a1.666,1.666,0,0,1,1.664,1.664V6.661",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fdfdfd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    d: "M6.7,6.7h5.543M6.7,9.472h5.543M6.7,12.243H9.472",
    transform: "translate(-3.058 -3.058)",
    fill: "none",
    stroke: "#fdfdfd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    d: "M21.1,22.835v-.708a2.493,2.493,0,0,1,2.059.732.158.158,0,0,0,.271-.124,2.142,2.142,0,0,0-2.33-2.22v-.708a.158.158,0,0,0-.266-.114l-1.6,1.512a.152.152,0,0,0,0,.219l0,0,1.6,1.512a.162.162,0,0,0,.223,0,.151.151,0,0,0,.043-.109Z",
    transform: "translate(-9.609 -9.852)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    d: "M19.632,15.82a3.642,3.642,0,1,0,3.642,3.642A3.642,3.642,0,0,0,19.632,15.82Z",
    transform: "translate(-7.932 -7.843)",
    fill: "none",
    stroke: "#fdfdfd",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignHistoryReportIcon);
export default __webpack_public_path__ + "static/media/campaign-history-report-icon.87aaa753057891563189b2e27be4f82f.svg";
export { ForwardRef as ReactComponent };